import styled from 'styled-components';

const StyledRect = styled.rect<{ $active: boolean }>`
	opacity: 0.05;
	fill: white;
	transition:
		opacity 0.3s ease,
		fill 0.3s ease;
`;

const StyledCircle = styled.circle<{ $active: boolean }>`
	fill: white;
	cx: ${(props) => (props.$active ? 10 : 20)}px;
	transition:
		fill 0.3s ease,
		cx 0.3s ease;
`;

const StyledSvg = styled.svg`
	cursor: pointer;

	&:hover {
		${StyledRect} {
			opacity: 1;
			fill: white;
		}

		${StyledCircle} {
			fill: black;
		}
	}
`;

export { StyledCircle, StyledRect, StyledSvg };
